import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=a118684a&"
import script from "./copyright.vue?vue&type=script&lang=js&"
export * from "./copyright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a118684a')) {
      api.createRecord('a118684a', component.options)
    } else {
      api.reload('a118684a', component.options)
    }
    module.hot.accept("./copyright.vue?vue&type=template&id=a118684a&", function () {
      api.rerender('a118684a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/description/components/copyright.vue"
export default component.exports